export default __webpack_public_path__ + "static/media/sensitiveCustomerIcon.ad80f886.svg";